import React from 'react'
import { Row } from 'reactstrap'
import styled from 'styled-components'

// justify-content: ${props => (props.center ? 'space-evenly' : 'initial')};

let Header = styled(Row)`
  padding-top: ${(props) => (props.small ? '5px' : '10px')};
  padding-bottom: ${(props) => (props.small ? '5px' : '10px')};
  justify-content: ${(props) => (props.center && 'space-around') || (props.between && 'space-between')};
`

const HeaderRow = (props) => {
  return (
    <Header between={props.between} small={props.small} center={props.center}>
      {props.children}
    </Header>
  )
}

export default HeaderRow
